import React from 'react';
import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Menu, Toolbar, UseAfter } from '@tencent/workbench';
import { config, TOOLBAR_ITEMS } from './config';
import { ChangeTemplateFeature } from './change-template-feature';
import { FIXED_KEYS_DOUBLE } from '@framework/workbench/schema/constant';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ChangeTemplateController {
    public constructor(@Loader(ChangeTemplateFeature) private loader: IDynamicLoader<ChangeTemplateFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'content')
    public shouldDisable(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getContent(info);
    }

    @Toolbar(config.id, 'shouldHide')
    public shouldContentHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.changeTemplateContent as any) ?? true);
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }


    // ssv的场景下需屏蔽会员功能
    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_BEAUTIFY, 'shouldHide')
    public shouldDoubleToolEfficiencyHide() {
        return !!this.feature.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType
            || !(appConfigInstance.getConfig(ToolbarFileMenuConfig.toolbarBeautify as any) ?? true);
    }
}
